import { render, staticRenderFns } from "./list-policies.vue?vue&type=template&id=4bf7639c&scoped=true&"
import script from "./list-policies.vue?vue&type=script&lang=js&"
export * from "./list-policies.vue?vue&type=script&lang=js&"
import style0 from "./list-policies.vue?vue&type=style&index=0&id=4bf7639c&prod&lang=scss&scoped=true&"
import style1 from "./list-policies.vue?vue&type=style&index=1&id=4bf7639c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf7639c",
  null
  
)

export default component.exports